export default "__VITE_ASSET__UBDKq1xe__"